import { FormattedMessage, useIntl } from 'gatsby-plugin-intl';
import * as React from 'react';
import { Col, Grid, Row } from 'react-styled-flexboxgrid';

import { Content } from '../components/common/Content';
import { Indent } from '../components/common/Indent';
import { Layout } from '../components/common/Layout';
import { StyledText } from '../components/common/StyledText';
import { SignUpForm } from '../components/forms/SignUpForm';
import { SEO } from '../components/common/Seo';
import { Modals } from '../components/modals/Modals';
import { Flex } from '../components/common/Flex';
import { Form } from '../components/common/Form';
import { StyledLink } from '../components/common/StyledLink';

const RegistrationPage = () => {
  const intl = useIntl();

  return (
    <Layout>
      <SEO title={intl.formatMessage({ id: 'seo.register.title' })} />
      <Content>
        <Grid>
          <Flex justify='center' align='center' direction='column'>
            <Form>
              <SignUpForm />
            </Form>
            <Flex>
              <StyledText color='textShadowed' size={0.9}>
                <Indent top={2}>
                  <Indent right={0.4}>
                    <FormattedMessage id='common.auth.alreadyHaveAccount' />
                  </Indent>
                  <StyledLink to='/login'>
                    <FormattedMessage id='common.signin' />
                  </StyledLink>
                </Indent>
              </StyledText>
            </Flex>
          </Flex>
        </Grid>
      </Content>
    </Layout>
  );
};

export default RegistrationPage;
